<template>
  <div>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <router-view name="rightPanel"></router-view>
  </div>
</template>

<script>
import { HTTP } from "@/utils/http";
import store from "@/store/index.js";
import Apis from "@/apis/index";
import Enums from "@/apis/_enums";
import {mapActions, mapState} from "vuex";
export default {
  name: "ClockDetailsMaster",
  mounted() {
    this.stationUid = this.$route.params.stationUid;
    this.clockUid = this.$route.params.clockUid;
    this.triggerLoadClock();
  },
  computed: {
    ...mapState({
      isConstraintModified: state => state.isConstraintModified
    })
  },
  beforeRouteUpdate(to, from, next) {
    if (!!this.isConstraintModified) {
      const message = confirm("Are you sure you want to exit ? Some changes aren\'t saved")
      if (message) {
        this.$store.commit('setStatusConstraint', false)
        next()
      }
    } else {
      next()
    }
  },
  watch: {
    $route: function(to, from) {
      this.stationUid = this.$route.params.stationUid;
      this.clockUid = this.$route.params.clockUid;
      this.triggerLoadClock();
    }
  },
  methods: {
    ...mapActions(["loadClock"]),
    triggerLoadClock: function() {
      console.log("Parameters for loading clock : ", this.$route.params);
      this.loadClock(this.$route.params);
    }
  }
};
</script>